import { z } from 'zod';
import { allPhases } from '../models';

/**
 * ULID regex matcher
 * https://medium.com/@juniooor/ulid-universally-unique-lexicographically-sortable-identifier-5544e3391660
 */
export const ULID_REGEX = /^[0-7][A-HJKMNP-TV-Z0-9]{25}$/;
export const zULID = z.string().regex(ULID_REGEX);

export const submissionsFilterValidator = z.object({
  workflowPhase: z
    .array(z.enum([allPhases[0]!, ...allPhases.slice(1)]))
    .default([]),
  journalId: z.array(zULID).default([]),
  documentType: z.array(z.string()).default([]),
  assigneeId: z.array(z.string()).default([]),
  searchParams: z.string().default(''),
  tagId: z.array(zULID).default([]),
  focusIssueId: z.array(zULID).default([]),
  userTags: z.array(z.string()).default([]),
  recommendations: z.array(z.string()).default([]),
  manuscripts: z.array(z.string()).default([]),
  bucket: z.string().default('').optional(),
  subBucket: z.string().default('').optional(),
  decisionType: z.array(z.string()).default([]).optional(),
  advancedSearch: z
    .array(
      z.object({
        field: z.string(),
        value: z.union([z.string(), z.array(z.string())])
      })
    )
    .optional()
});
